export const twitchConstants = {
  TWITCH_LOADING: 'TWITCH_LOADING',
  CHANNEL_DETAILS: 'CHANNEL_DETAILS',
  CHANNEL_DETAILS_FAIL: 'CHANNEL_DETAILS_FAIL',
  INGEST_DETAILS: 'INGEST_DETAILS',
  INGEST_DETAILS_FAIL: 'INGEST_DETAILS_FAIL',
};
